(ns common.schema.entities.survey.survey-question.core
  "Common entity-type definition of the survey question. It was an entry in
   `common.schema.entity-types`. The backend registry needs it, so that the
   dedicated index builds the survey question documents with the calculated fields."
  (:require
   [common.schema.entities.survey.survey-question.schema :as survey-question]
   [common.schema.entities.survey.survey-question.permissions :as permissions]))

(def entity-type-definition
  {:entity-type                  :entity.type/survey-question
   :schema                       survey-question/schema
   :name                         {:en "Survey question"}
   :plural                       {:en "Survey questions"}
   :icon                         :fa-question
   :read-permissions-check-fn    permissions/read-permissions?
   :disable-permissions-check-fn permissions/disable-permissions?})
